export default __webpack_public_path__ + "static/media/group-3@2x.6f021fe7.png";